
import { Component, Vue, Prop } from "vue-property-decorator"

@Component({})
export default class ViewFolderItem extends Vue {
	@Prop({ type: String, default: null })
	activeItemId!: string | null;

	@Prop({ type: String, default: "" })
	itemId!: string;

	@Prop({ type: String, default: "" })
	title!: string;

	@Prop({ type: Number, default: null })
	itemCount!: number | null;

	public itemSelected (itemId: string) {
		this.$emit("itemSelected", itemId)
	}
}
